<template>
  <div style="background-color: #fff;min-height: 100vh;">
    <template v-if="showAll">
      <div class="header-filter">
        <img class="filter-bg" src="./filter-bg.png" />
        <div class="filter-content">
          <div class="split-bar"></div>
          <!-- 年级 -->
          <div class="filter-row1">
            <filterDate v-model="filterForm.date" @change="search()"></filterDate>
            <div class="filter-input">
              <input placeholder="请输入学生姓名" v-model="filterForm.userName" @change="search()" />
              <div class="search-icon" @click="search()">
                <!-- <img src="./search-icon.png" /> -->
                <van-icon name="search" />
              </div>
            </div>
            <div class="more-filter" @click="moreFilter">
              <img src="./filter-icon.png" />
            </div>
          </div>
          <!-- <div class="split-bar"></div> -->
          <!-- 四种状态 -->
          <div class="split-bar"></div>
          <div class="filter-row3">
            <div class="type-box">
              <div @click="changeType('')" class="type-item type1" :class="activeType === '' ? 'type1ac' : ''">
                <div class="type-num">{{ typeNum.personNum }}</div>
                <div class="type-name">共计</div>
              </div>
            </div>
            <div class="type-box">
              <div @click="changeType(0)" class="type-item type2" :class="activeType === 0 ? 'type2ac' : ''">
                <div class="type-num">{{ typeNum.atDormNum + typeNum.normalNumberOfReturnees + typeNum.lateDormNum + typeNum.notLeavingYetDormNum }}</div>
                <div class="type-name">在寝</div>
              </div>
            </div>
            <div class="type-box">
              <div @click="changeType(1)" class="type-item type3" :class="activeType === 1 ? 'type3ac' : ''">
                <div class="type-num">{{ typeNum.notDormNum + typeNum.normalNumberOfDepartures + typeNum.lateDepartureDormNum + typeNum.notReturnedNum }}</div>
                <div class="type-name">不在寝</div>
              </div>
            </div>
            <template v-if="tabType !== null">
              <template v-if="tabType == 0"></template>
              <template v-else-if="tabType == 1">
                <div class="type-box">
                  <div @click="changeType(7)" class="type-item type6" :class="activeType === 7 ? 'type6ac' : ''">
                    <div class="type-num">{{ typeNum.lateDepartureDormNum }}</div>
                    <div class="type-name">迟离</div>
                  </div>
                </div>
              </template>
              <template v-else-if="tabType == 2">
                <div class="type-box">
                  <div @click="changeType(2)" class="type-item type5" :class="activeType === 2 ? 'type5ac' : ''">
                    <div class="type-num">{{ typeNum.lateDormNum }}</div>
                    <div class="type-name">晚归</div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="type-box">
                  <div @click="changeType(7)" class="type-item type6" :class="activeType === 7 ? 'type6ac' : ''">
                    <div class="type-num">{{ typeNum.lateDepartureDormNum }}</div>
                    <div class="type-name">迟离</div>
                  </div>
                </div>
                <div class="type-box">
                  <div @click="changeType(2)" class="type-item type5" :class="activeType === 2 ? 'type5ac' : ''">
                    <div class="type-num">{{ typeNum.lateDormNum }}</div>
                    <div class="type-name">晚归</div>
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <template v-if="filterForm.timeType[0] == 1 || filterForm.timeType[0] == 3">
                <!-- <div class="type-box">
                  <div @click="changeType(6)" class="type-item type2" :class="activeType === 6 ? 'type2ac' : ''">
                    <div class="type-num">{{ typeNum.normalNumberOfDepartures }}</div>
                    <div class="type-name">正常离寝</div>
                  </div>
                </div> -->
                <div class="type-box">
                  <div @click="changeType(7)" class="type-item type6" :class="activeType === 7 ? 'type6ac' : ''">
                    <div class="type-num">{{ typeNum.lateDepartureDormNum }}</div>
                    <div class="type-name">迟离</div>
                  </div>
                </div>
                <!-- <div class="type-box">
                  <div @click="changeType(8)" class="type-item type5" :class="activeType === 8 ? 'type5ac' : ''">
                    <div class="type-num">{{ typeNum.notLeavingYetDormNum }}</div>
                    <div class="type-name">未离</div>
                  </div>
                </div> -->
              </template>
              <template v-else-if="filterForm.timeType[0] == 2 || filterForm.timeType[0] == 4">
                <!-- <div class="type-box">
                  <div @click="changeType(5)" class="type-item type2" :class="activeType === 5 ? 'type2ac' : ''">
                    <div class="type-num">{{ typeNum.normalNumberOfReturnees }}</div>
                    <div class="type-name">正常归寝</div>
                  </div>
                </div> -->
                <div class="type-box">
                  <div @click="changeType(2)" class="type-item type5" :class="activeType === 2 ? 'type5ac' : ''">
                    <div class="type-num">{{ typeNum.lateDormNum }}</div>
                    <div class="type-name">晚归</div>
                  </div>
                </div>
                <!-- <div class="type-box">
                  <div @click="changeType(3)" class="type-item type5" :class="activeType === 3 ? 'type5ac' : ''">
                    <div class="type-num">{{ typeNum.notReturnedNum }}</div>
                    <div class="type-name">未归</div>
                  </div>
                </div> -->
              </template>
              <template v-else>
                <!-- <div class="type-box">
                  <div @click="changeType(0)" class="type-item type2" :class="activeType === 0 ? 'type2ac' : ''">
                    <div class="type-num">{{ typeNum.atDormNum }}</div>
                    <div class="type-name">在寝</div>
                  </div>
                </div>
                <div class="type-box">
                  <div @click="changeType(1)" class="type-item type3" :class="activeType === 1 ? 'type3ac' : ''">
                    <div class="type-num">{{ typeNum.notDormNum }}</div>
                    <div class="type-name">不在寝</div>
                  </div>
                </div> -->
              </template>
            </template>

            <div class="type-box">
              <div @click="changeType(4)" class="type-item type4" :class="activeType === 4 ? 'type4ac' : ''">
                <div class="type-num">{{ typeNum.leaveDormNum }}</div>
                <div class="type-name">请假</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 下方列表 -->
      <div class="list-content">
        <div class="floor-info" v-if="buildAndDormList && buildAndDormList.length > 0">
          <!-- 左侧抽屉 -->
          <div class="floor-left">
            <van-collapse v-model="activeBuilding" accordion @change="changeCollapse">
              <van-collapse-item v-for="build in buildAndDormList" :title="build.dormOrganName" :name="build.dormOrganId" :class="activeBuildingRecord == build.dormOrganId ? 'build-item-active' : ''">
                <div v-for="floor in build.childList" class="floor-item" :class="activeFloor == floor.dormOrganId ? 'floor-item-active' : ''" @click="changeFloor(floor)">
                  {{ floor.dormOrganName }}
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
          <!-- 右侧列表 -->
          <div class="floor-right">
            <div class="statis-info">
              <div class="statis-content">
                <img src="./tongji.png" />
                <div>{{ getBuildName() }}</div>
                <div>{{ buildNum.typeNum }}/{{ buildNum.personNum }}</div>
              </div>
              <div class="split-bar-border"></div>
            </div>
            <div class="dorm-list">
              <div class="dorm-info" v-for="dorm in dormList">
                <div class="dorm-name">
                  <img src="./dorm-arrow.png" />
                  <div style="margin-left: 0.25rem;">{{ dorm.dormOrganName }}</div>
                </div>
                <div class="dorm-members">
                  <div class="members-item" v-for="members in dorm.dormUsers">
                    <div class="members-item-inner" :class="members.userId ? (members.tolayStatus == 0 || members.tolayStatus == 2 || members.tolayStatus == 5 || members.tolayStatus == 8 || members.tolayStatus == 10 ? '' : 'no-back') : 'empty-bed'" @click="openInfo(members)">
                      <div class="members-name">
                        <div>{{ members.userName }}</div>
                      </div>
                      <!-- 假期列表不为空 -->
                      <div v-if="(members.leaveListVMS && members.leaveListVMS.length) || members.tolayStatus == 4 || members.tolayStatus == 10 || members.tolayStatus == 11" class="members-tip" :style="{ background: 'red' }">
                        假
                      </div>
                      <template v-else>
                        <template v-if="members.continuedDay">
                          <div v-if="members.tolayStatus == 0||members.tolayStatus == 2||members.tolayStatus == 5||members.tolayStatus == 8" class="members-tip" :style="{ background: 'red' }">
                            {{ members.continuedDay }}
                          </div>
                          <div v-if="members.tolayStatus == 1||members.tolayStatus == 3||members.tolayStatus == 6||members.tolayStatus == 7" class="members-tip" :style="{ background: '#FAAD14' }">
                            {{ members.continuedDay }}
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-else class="floor-info">
          <div class="floor-left">
            <van-collapse v-model="activeBuilding" accordion @change="changeCollapse">
              <van-collapse-item v-for="build in buildList" :title="build.dormOrganName" :name="build.dormOrganId" :class="activeBuildingRecord == build.dormOrganId ? 'build-item-active' : ''">
                <div v-for="floor in build.childList" class="floor-item" :class="activeFloor == floor.dormOrganId ? 'floor-item-active' : ''" @click="changeFloor(floor)">
                  {{ floor.dormOrganName }}
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
          <div class="floor-right">
              <div style="min-height: 65vh;text-align: center;line-height: 30vh;color: #aaa;font-size: 0.9rem;">
                  暂无数据
              </div>
          </div>
        </div> -->
        <div v-else style="min-height: 65vh;text-align: center;line-height: 30vh;color: #aaa;font-size: 0.9rem;">
          暂无数据
        </div>
      </div>
      <infoPop ref="infoPop" @refresh="search('rember')"></infoPop>
      <filterPop @getSelectFloorTimeType="getSelectFloorTimeType" ref="filterPop" @confirm="filterPopConfirm" :classDataList="classDataList" :deptDataList="deptDataList" :buildList="buildList" :timeTypeList="timeTypeList"></filterPop>
    </template>
    <template v-else>
      <div class="no-permission">
        <div class="permission-msg">您没有使用权限</div>
        <img class="permission-bg" src="./filter-bg.png" />
      </div>
    </template>
  </div>
</template>

<script>
import infoPop from './infoPop';
import filterPop from './filterPop';
import filterDate from './filterDate';
import filterCheckBox from './filterCheckBox.vue';
import moment from 'moment';
export default {
  components: {
    infoPop,
    filterPop,
    filterDate,
    filterCheckBox
  },
  name: 'go-back',
  data() {
    return {
      showAll: false,
      errorMsg: '',
      schoolId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).schoolId : '1070770900580810752',
      teacherId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).id : '1500216794534588416',
      // 时段信息
      timeTypeList: [],
      // 班级信息
      classDataList: [],
      // 部门信息
      deptDataList: [],
      // 宿舍楼信息
      buildAndDormList: [],
      // 类型选中
      activeType: '',
      // 展开楼
      activeBuilding: null,
      // 上次点击展开记录用来回显名字
      activeBuildingRecord: null,
      // 选中楼层
      activeFloor: null,
      typeNum: {
        personNum: 0,
        atDormNum: 0,
        notDormNum: 0,
        leaveDormNum: 0,
        lateDormNum: 0,
        lateDepartureDormNum: 0,
        normalNumberOfReturnees: 0,
        normalNumberOfDepartures: 0,
        notReturnedNum: 0,
        notLeavingYetDormNum: 0
      },
      buildNum: {
        typeNum: 0,
        personNum: 0
      },
      filterForm: {
        buildList: ['all'],
        classList: ['all'],
        deptList: [],
        timeType: [],
        date: moment(new Date()).format('YYYY-MM-DD'),
        userName: null
      },
      tabType: null
    };
  },
  mounted() {
    const loading = this.$toast.loading({
      duration: 0,
      message: '加载中',
      forbidClick: true,
      getContainer: '#app'
    });
    this.getFilter()
      .then(res => {
        // loading.clear();
        this.search();
      })
      .catch(e => {
        loading.clear();
        if (e.code == 501) {
          this.errorMsg = e.msg;
        }
        this.$toast.fail({ getContainer: '#app', message: e.msg });
      });
  },
  computed: {
    dormList: {
      get() {
        // 获取选中元素
        let selectObj = this.findItem(this.buildAndDormList, 'dormOrganId', this.activeFloor ? this.activeFloor : this.activeBuildingRecord, 'childList');
        let tempBuildAndDormList = [];
        if (selectObj) {
          this.getLeafItem(tempBuildAndDormList, selectObj.childList);
        }
        return tempBuildAndDormList;
      },
      set() {}
    },
    dormStatusList: {
      get() {
        if (this.activeType !== 0 && this.activeType !== 1) {
          if (this.activeType === '') {
            return [];
          }
          return [this.activeType];
        } else {
          if (this.activeType == 0) {
            return [0, 2, 5, 8];
          }
          if (this.activeType == 1) {
            return [1, 3, 6, 7];
          }

          return [];
        }
      }
    }
  },
  methods: {
    getFilter() {
      return new Promise((resolve, reject) => {
        this.axios
          .get(`student-consumer/api/dormitory/getOrgDataByTeacherId`, {
            params: {
              teacherId: this.teacherId,
              schoolId: this.schoolId
            }
          })
          .then(res => {
            if (res.code == 200) {
              this.classDataList = res.data.classDataList ? res.data.classDataList : [];
              this.buildList = res.data.dormDataList ? res.data.dormDataList : [];
              this.deptDataList = res.data.deptDataList ? res.data.deptDataList : [];
              this.showAll = true;
              resolve(res);
            } else {
              this.showAll = false;
              reject(res);
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    gettimeType() {
      
      this.axios
        .post(`student-consumer/api/dormitory/findDormTimeData`,{
            dormOrganIds: this.handleBuild(),
          })
        .then(res => {
          if (res.code == 200) {
            this.timeTypeList = res.data;
          } else {
            this.timeTypeList = [];
          }
        })
        .catch(e => {
          this.$toast.fail({ getContainer: '#app', message: e.msg });
        });
    },


    // 根据选中的宿舍楼获取时段
    getSelectFloorTimeType (dormIds) {
       
      this.axios
        .post(`student-consumer/api/dormitory/findDormTimeData`,{
            dormOrganIds:dormIds,
          })
        .then(res => {
          if (res.code == 200) {
            this.timeTypeList = res.data;
          } else {
            this.timeTypeList = [];
          }
        })
        .catch(e => {
          this.$toast.fail({ getContainer: '#app', message: e.msg });
        });
    },
    
    




    async getTotalData() {
      let orgIds = [...this.handleClass(), ...this.handleDept()];
      let filterObj = {
        // classIds: this.handleClass(),
        orgIds: orgIds,
        dormOrganIds: this.handleBuild(),
        findDate: this.filterForm.date,
        userName: this.filterForm.userName,
        schoolId: this.schoolId,
        teacherId: this.teacherId,
        timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : undefined
      };
      await this.axios
        .post(`student-consumer/api/dormitory/getDormStatisticsDataNew`, filterObj)
        .then(res => {
          if (res.code == 200) {
            this.typeNum.personNum = res.data.personNum;
            this.typeNum.atDormNum = res.data.atDormNum;
            this.typeNum.notDormNum = res.data.notDormNum;
            this.typeNum.leaveDormNum = res.data.leaveDormNum;
            this.typeNum.lateDormNum = res.data.lateDormNum;
            this.typeNum.lateDepartureDormNum = res.data.lateDepartureDormNum;
            this.typeNum.normalNumberOfReturnees = res.data.normalNumberOfReturnees;
            this.typeNum.normalNumberOfDepartures = res.data.normalNumberOfDepartures;
            this.typeNum.notReturnedNum = res.data.notReturnedNum;
            this.typeNum.notLeavingYetDormNum = res.data.notLeavingYetDormNum;
          } else {
            this.$toast.fail({ getContainer: '#app', message: res.msg });
          }
        })
        .catch(e => {
          this.$toast.fail({ getContainer: '#app', message: e.msg });
        });
    },
    async getDormData(type) {
      let orgIds = [...this.handleClass(), ...this.handleDept()];
      let filterObj = {
        orgIds: orgIds,
        // classIds: this.handleClass(),
        dormOrganIds: this.handleBuild(),
        dormStatus: this.activeType,
        dormStatusList: this.dormStatusList,
        findDate: this.filterForm.date,
        userName: this.filterForm.userName,
        schoolId: this.schoolId,
        teacherId: this.teacherId,
        timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : undefined
      };

      // 获取宿舍数据
      const res1 = await this.axios
        .post(`student-consumer/api/dormitory/getDormReturnToBedData`, filterObj)
        .then(res => {
          if (res.data && res.data.dormDataVMS) {
            this.buildAndDormList = res.data.dormDataVMS;
            if (type == 'rember') {
              // 保持宿舍/层数选定记录
              let buildObj = this.findItem(this.buildAndDormList, 'dormOrganId', this.activeBuilding, 'childList');
              let floorObj = this.findItem(this.buildAndDormList, 'dormOrganId', this.activeFloor, 'childList');
              if (!buildObj) {
                this.activeBuilding = this.buildAndDormList[0] ? this.buildAndDormList[0].dormOrganId : null;
                this.activeBuildingRecord = this.activeBuilding;
              }
              if (!buildObj && !floorObj) {
                this.activeFloor = this.buildAndDormList[0] && this.buildAndDormList[0].childList[0] ? this.buildAndDormList[0].childList[0].dormOrganId : null;
              }
            } else {
              // 第一次进来
              this.activeBuilding = this.buildAndDormList[0] ? this.buildAndDormList[0].dormOrganId : null;
              this.activeBuildingRecord = this.activeBuilding;
              this.activeFloor = null;
            }
            this.getDormStatisticsNum(this.buildAndDormList[0].atDormUserNum,this.buildAndDormList[0].dormUserNum);
          } else {
            this.buildAndDormList = [];
            this.activeBuilding = null;
            this.activeBuildingRecord = null;
            this.activeFloor = null;
            this.buildNum.personNum = 0;
            this.buildNum.typeNum = 0;
          }
          return res;
        })
        .catch(e => {
          return e;
        });
      return res1;
    },
    async getDormStatisticsNum(a,b) {
      // 统计查询
      this.$nextTick(async () => {
        let orgIds = [...this.handleClass(), ...this.handleDept()];
        let filterObj = {
          orgIds: orgIds,
          // classIds: this.handleClass(),
          dormOrganId: this.activeFloor ? this.activeFloor : this.activeBuildingRecord,
          dormStatus: this.activeType === '' ? 0 : this.activeType,
          dormStatusList: this.activeType === '' ? [0, 2, 5, 8] : this.dormStatusList,
          findDate: this.filterForm.date,
          userName: this.filterForm.userName,
          schoolId: this.schoolId,
          teacherId: this.teacherId,
          timeType: this.filterForm.timeType[0] ? this.filterForm.timeType[0] : undefined
        };
        // 获取楼层和宿舍右上角统计
        this.buildNum.personNum = b;
        this.buildNum.typeNum = a;
      });
    },
    handleClass() {
      let tempClassVal = [];
      if (this.filterForm.classList.indexOf('all') != -1) {
        // 有全部情况
        if (this.filterForm.classList[0] == 'all') {
          // 第一个为全部情况
          this.getLeaf(tempClassVal, this.classDataList);
        } else {
          // 其余某个为全部，递归父级;
          let classItem = this.findItem(this.classDataList, 'id', this.filterForm.classList[this.filterForm.classList.indexOf('all') - 1]);
          if (classItem) {
            this.getLeaf(tempClassVal, classItem.children);
          }
        }
      } else {
        // let classItem = this.findItem(this.classDataList, 'id', this.filterForm.classList[this.filterForm.classList.length - 1]);
        // if(classItem){
        //   if(classItem.children&&classItem.children.length>0){
        //     this.getLeaf(tempClassVal, classItem.children);
        //   }else{
        //     tempClassVal = [classItem.id]
        //   }
        // }
        tempClassVal = [this.filterForm.classList[this.filterForm.classList.length - 1]];
      }
      return tempClassVal;
    },
    handleDept() {
      let tempDeptVal = [];
      if (this.filterForm.deptList.indexOf('all') != -1) {
        // 有全部情况
        if (this.filterForm.deptList[0] == 'all') {
          // 第一个为全部情况
          this.getLeaf(tempDeptVal, this.deptDataList);
        } else {
          // 其余某个为全部，递归父级;
          let deptItem = this.findItem(this.deptDataList, 'id', this.filterForm.deptList[this.filterForm.deptList.indexOf('all') - 1]);
          if (deptItem) {
            this.getLeaf(tempDeptVal, deptItem.children);
          }
        }
      } else {
        let deptItem = this.findItem(this.deptDataList, 'id', this.filterForm.deptList[this.filterForm.deptList.length - 1]);
        if (deptItem) {
          if (deptItem.children && deptItem.children.length > 0) {
            this.getLeaf(tempDeptVal, deptItem.children);
          } else {
            tempDeptVal = [deptItem.id];
          }
        }
        // this.getLeaf(tempDeptVal, deptItem.children);
        // tempDeptVal = [this.filterForm.deptList[this.filterForm.classList.length - 1]];
      }
      return tempDeptVal;
    },
    handleBuild() {
      let tempBuildVal = [];
      if (this.filterForm.buildList.indexOf('all') != -1) {
        tempBuildVal = this.buildList && this.buildList.map(item => {
          return item.dormOrganId;
        });
      } else {
        tempBuildVal = JSON.parse(JSON.stringify(this.filterForm.buildList));
      }
      return tempBuildVal;
    },
    getBuildName() {
      if (this.activeFloor) {
        let floorItem = this.findItem(this.buildList, 'dormOrganId', this.activeFloor, 'childList');
        if (floorItem) {
          let buildItem = this.findItem(this.buildList, 'dormOrganId', floorItem.parentId, 'childList');
          return buildItem ? `${buildItem.dormOrganName}/${floorItem.dormOrganName}` : '';
        } else {
          return '';
        }
      } else {
        let buildItem = this.findItem(this.buildList, 'dormOrganId', this.activeBuildingRecord, 'childList');
        return buildItem ? buildItem.dormOrganName : '';
      }
    },
    getFloorTypeNum() {
      let num = 0;
      this.dormList.map(item => {
        let tempMemberList = item.dormMember.filter(child => {
          return child.userId;
        });
        num += tempMemberList.length;
      });
      return num;
    },
    filterPopConfirm(data) {
      this.activeType = '';
      this.filterForm = data;
      this.search();
    },
    async getTabType() {
      let filterObj = {
        dormOrganIds: this.handleBuild()
      };
      const result = await this.axios
        .post(`student-consumer/api/dormitory/findDormTimeData`, filterObj)
        .then(res => {
          this.tabType = res.data;
          return res;
        })
        .catch(e => {
          return e;
        });
      return result;
    },
    async search(type) {
      let loading = null;
      loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });
      // 如果没选中时段且是今天那么调用后台获取当前时段
      if (this.filterForm.timeType.length == 0 && this.filterForm.date == moment().format('YYYY-MM-DD')) {
        this.getTabType();
      } else {
        this.tabType = null;
      }
      // await this.getTotalData();
      this.getTotalData();
      const res = await this.getDormData(type);
      if (res.code == 200) {
        loading.clear();
      } else {
        this.$toast.fail({ getContainer: '#app', message: res.msg });
      }
    },
    // 修改折叠建筑
    changeCollapse(e) {
      if (e) {
        // 选中建筑清空楼层
        let a = this.buildAndDormList.find(item => item.dormOrganId == e);
        this.activeBuildingRecord = e;
        this.activeFloor = null;
        this.getDormStatisticsNum(a.atDormUserNum,a.dormUserNum);
      } else {
        let a = this.buildAndDormList.find(item => item.dormOrganId == this.activeBuilding);
        this.activeFloor = null;
        this.getDormStatisticsNum(a.atDormUserNum,a.dormUserNum);
      }
    },

    // 修改在寝状态
    async changeType(type) {
      this.activeType = type;
      const loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });
      // await this.getTotalData();
      this.getTotalData();
      const res = await this.getDormData();
      if (res.code == 200) {
        loading.clear();
      } else {
        this.$toast.fail({ getContainer: '#app', message: res.msg });
      }
    },
    changeFloor(floor) {
      console.log('floor',floor)
      // 修改层数只查询楼层信息
      this.activeFloor = floor.dormOrganId;
      this.getDormStatisticsNum(floor.atDormUserNum,floor.dormUserNum);
    },
    moreFilter() {
      this.gettimeType()
      this.$refs.filterPop.open(this.filterForm);
    },
    openInfo(data) {
      if (data.userId) {
        this.$refs.infoPop.open(data, this.filterForm.date, this.filterForm.timeType[0] ? this.filterForm.timeType[0] : null);
      }
    },
    getLeaf(valueList, list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].children && list[i].children.length > 0) {
          this.getLeaf(valueList, list[i].children);
        } else {
          valueList.push(list[i].id);
        }
      }
    },
    getLeafItem(valueList, list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].childList && list[i].childList.length > 0) {
          this.getLeafItem(valueList, list[i].childList);
        } else {
          valueList.push(list[i]);
        }
      }
    },
    findItem(list, key, value, children = 'children') {
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (item[key] === value) {
          return item;
        }
        if (item[children] && item[children].length > 0) {
          if (this.findItem(item[children], key, value)) {
            return this.findItem(item[children], key, value);
          }
        }
      }
      return null;
    },
    getParams(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var r = window.location.search.substr(1).match(reg);
      return r ? unescape(r[2]) : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.header-filter {
  width: 100%;
  position: relative;
  .filter-bg {
    height: 8.2rem;
    width: 100%;
    position: absolute;
    z-index: 1;
  }
  .filter-content {
    position: relative;
    z-index: 5;
  }

  .filter-row1 {
    display: flex;
    align-items: center;
    padding: 0 1rem;
    ::v-deep.date-box {
      .date-arrow,
      .date-show {
        color: #fff;
      }
    }
    .filter-input {
      // padding-left: 0.7rem;
      padding-right: 0rem;
      flex: 1;
      flex-shrink: 0;
      display: flex;
      // border-radius: 0.9375rem;
      overflow: hidden;
      align-items: center;
      .search-icon {
        color: #fff;
        text-align: center;
        width: 2rem;
        flex-shrink: 0;
        // padding-top: 0.2rem;
        // border-radius: 0.5rem;
        height: 1.875rem;
        line-height: 1.875rem;
        background-color: #3775ff;
        padding-right: 0.3rem;
        border-radius: 0 0.9375rem 0.9375rem 0;
        border: 1px solid #fff;
        // background-color: #3775ff;

        // img {
        //   height: 0.9rem;
        // }
      }
      input {
        border-radius: 0.9375rem 0 0 0.9375rem;
        width: calc(100% - 2rem);
        box-sizing: border-box;
        height: 1.875rem;
        border: 0;
        outline: 0;
        flex: 1;
        padding: 0.4375rem 0 0.4375rem 0.7rem;
        font-size: 0.75rem;
        color: #333;
        background: #fff;
        &::placeholder {
          color: #999;
        }
      }
    }
    .more-filter {
      padding-left: 1rem;
      width: 2rem;
      height: 1rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .filter-row3 {
    padding: 0 0.75rem;
    display: flex;
    // margin-top: 1rem;
    .type-box {
      padding: 0 0.2rem;
      // width: 20%;
      flex: 1;
      .type-item {
        background-color: #333;
        height: 4.5rem;
        width: 100%;
        padding: 0.5rem 0.5rem;
        .type-num {
          font-size: 1.25rem;
        }
        .type-name {
          // margin-left: 0.3rem;
          margin-top: 0.625rem;
          font-size: 0.7rem;
        }
      }
      .type1 {
        background: url(./type1.png);
        background-size: 100% 100%;
      }
      .type1ac {
        background: url(./type1ac.png);
        background-size: 100% 100%;
      }
      .type2 {
        background: url(./type2.png);
        background-size: 100% 100%;
      }
      .type2ac {
        background: url(./type2ac.png);
        background-size: 100% 100%;
      }
      .type3 {
        background: url(./type3.png);
        background-size: 100% 100%;
      }
      .type3ac {
        background: url(./type3ac.png);
        background-size: 100% 100%;
      }
      .type4 {
        background: url(./type4.png);
        background-size: 100% 100%;
      }
      .type4ac {
        background: url(./type4ac.png);
        background-size: 100% 100%;
      }
      .type5 {
        background: url(./type5.png);
        background-size: 100% 100%;
      }
      .type5ac {
        background: url(./type5ac.png);
        background-size: 100% 100%;
      }
	  .type6 {
	    background: url(./type6.png);
	    background-size: 100% 100%;
	  }
	  .type6ac {
	    background: url(./type6ac.png);
	    background-size: 100% 100%;
	  }
    }
  }
  .grade-tab {
    flex: 1;
    padding: 0 0.75rem;
    overflow: hidden;
    .grade-inner {
      width: 100%;
      overflow: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .class-tab {
    width: 100%;
    padding: 0 0.75rem;
    overflow: hidden;
    .class-inner {
      width: 100%;
      overflow: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}

.list-content {
  margin-top: 0.5rem;
  position: relative;
  z-index: 5;
  .floor-info {
    display: flex;
    .floor-left {
      width: 5.625rem;
      padding-top: 0.5rem;
      flex-shrink: 0;
      height: 100%;
      overflow: auto;
      max-height: 80vh;
      &::-webkit-scrollbar {
        display: none;
      }
      .build-item-active::before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0.625rem;
        height: 1rem;
        width: 0.25rem;
        background: url('./collapse-active-icon.png');
        background-size: 100% 100%;
        z-index: 1;
      }
      ::v-deep.van-collapse {
        .van-collapse-item {
          .van-cell {
            position: relative;
            .van-cell__title {
              font-weight: bold;
              line-height: 1rem;
            }
            .van-icon {
              display: none;
            }
          }
          // .van-collapse-item__title--expanded::before {
          //   content: '';
          //   display: block;
          //   position: absolute;
          //   left: 0;
          //   top: 0.625rem;
          //   height: 1rem;
          //   width: 0.25rem;
          //   background: url('./collapse-active-icon.png');
          //   background-size: 100% 100%;
          // }
          .van-collapse-item__content {
            padding: 0 1rem;
            color: #333;
            .floor-item {
              // colo
              padding: 0.625rem 0;
            }
            .floor-item-active {
              color: #3775ff;
            }
          }
        }
      }
    }
    .floor-right {
      flex: 1;
      padding-top: 1rem;
      .statis-info {
        padding-right: 1rem;
        padding-left: 0.5rem;
        text-align: right;
        position: relative;
        .statis-content {
          display: inline-flex;
          align-items: center;
          line-height: 1.25rem;
          & > * + * {
            margin-left: 0.5rem;
            font-size: 0.875rem;
          }
          img {
            height: 0.8rem;
          }
        }
        .split-bar-border {
          width: 100%;
          height: 1px;
          background-color: #e8e8e8;
          margin-top: 0.3rem;
        }
      }
      .dorm-list {
        min-height: 65vh;
        max-height: 80vh;
        overflow: auto;
        width: 100%;
        padding: 0.625rem 0.5rem;
        .dorm-info {
          &:not(:first-child) {
            margin-top: 0.6rem;
          }
          .dorm-name {
            display: flex;
            align-items: center;
            img {
              height: 0.8rem;
            }
          }
          .dorm-members {
            display: flex;
            margin-top: 0.625rem;
            flex-wrap: wrap;
            .members-item {
              // display: inline-block;
              width: 33%;
              text-align: center;
              color: white;
              font-size: 0.875rem;
              padding-right: 0.3rem;
              padding-bottom: 0.3rem;
              .members-item-inner {
                background-color: #3775ff;
                padding: 0.625rem 0;
                border-radius: 0.3rem;
                position: relative;
                overflow: hidden;
                .members-tip {
                  border-radius: 0 0 0 0.6rem;
                  position: absolute;
                  right: 0;
                  top: 0;
                  height: 0.875rem;
                  width: 1.375rem;
                  font-size: 0.625rem;
                  color: #fff;
                }
                .members-name {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  line-clamp: 1;
                  -webkit-line-clamp: 1; /* 可以显示的行数，超出部分用...表示*/
                  -webkit-box-orient: vertical;
                  & > div {
                    height: 1.1rem;
                    line-height: 1.1rem;
                  }
                }
              }
              .empty-bed {
                background-color: transparent;
                // border: 1px dashed #aaa;
                background-color: #eee;
                border-radius: 0.3rem;
                .members-tip {
                  display: none;
                }
              }
              .no-back {
                // opacity: 0.5;
                background-color: #eee;
                color: #333;
              }
            }
          }
        }
      }
    }
  }
}
.split-bar {
  height: 0.8rem;
}
.textalign-left {
  ::v-deep.van-tabs__wrap {
    height: 2rem;
    .van-tab {
      flex: none;
      padding: 0 1rem;
    }
    .van-tabs__nav--line {
      padding-bottom: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .van-tabs__line {
      bottom: 0;
    }
    .van-tab--active {
      font-weight: bold;
    }
  }
}
.no-permission {
  position: relative;
  width: 100%;
  .permission-msg {
    text-align: center;
    position: relative;
    z-index: 2;
    line-height: 20vh;
  }
  .permission-bg {
    top: 0;
    left: 0;
    height: 25vh;
    width: 100%;
    position: absolute;
    z-index: 1;
  }
}
</style>
